import { render, staticRenderFns } from "./newsOrProblem.vue?vue&type=template&id=c610ab5c&scoped=true"
import script from "./newsOrProblem.vue?vue&type=script&lang=js"
export * from "./newsOrProblem.vue?vue&type=script&lang=js"
import style0 from "./newsOrProblem.vue?vue&type=style&index=0&id=c610ab5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c610ab5c",
  null
  
)

export default component.exports